import '../../assets/index.less'

const AgreementFace = () => {
  document.title = '人脸识别服务协议'
  return (
    <div className="page agreement">
      <div className="main">
        <img className="logo" src={require('../../assets/logo.png')} alt="" />
        <div className="h1">人脸识别服务协议</div>
        <div className="p">版本更新日期：2022年6月20日</div>
        <div className="p">版本生效日期：2022年6月20日</div>
        <div style={{ height: '10px' }}></div>
        <div className="p">
          欢迎您使用人脸识别功能，本服务协议是上海商汤数字科技有限公司（“商汤”）与用户（“您”）为明确服务内容而签订的有效协议。在接受本协议之前，请仔细阅读本协议的全部内容。
        </div>
        <div className="p">
          请您务必审慎阅读、充分理解各条款内容，特别是涉及您重大权益的条款，特别是免除或者限制商汤责任的条款、限制用户权利的条款、约定争议解决方式和司法管辖的条款等，以及开通或使用某项服务的单独协议或规则（如有）。前述条款可能以加粗、加下划线等形式提示您注意本协议内容中以加粗方式显著标识的条款，请您着重阅读。您点击“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。如对注册协议内容有任何疑问、意见或建议，您可通过senserobot@sensetime.com与我们联系。
        </div>
        <div className="p">
          本协议下我们推定您为具备完全民事权利能力和与所从事的民事行为相适应的行为能力的中华人民共和国大陆地区法律实体，且并非任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象（“受限对象”）。如果您因年龄、智力等因素而不具有完全民事行为能力，请在监护人的陪同下阅读和同意本协议。
        </div>
        <div className="p">
          如果您是中国大陆地区以外的用户，您订立或履行本协议的行为需要同时遵守您所属国家或地区的法律。您应保证，您订立并履行本协议的行为不违反您所属的国家或地区法律法规的强制性规定。若您并非前述适格主体（或未取得监护人同意）但仍继续签署本协议的，商汤有权在获知相关情况后拒绝或终止向您提供服务，您（及您的监护人）须自行承担相关损失。
        </div>
        <div className="h3">一、功能说明</div>
        <div className="p">
          为识别用户的棋手身份，提供人脸识别服务，商汤在提供人脸识别服务之前，采用人脸识别核身验证功能对棋手的身份进行认证，用于验证操作人是否为棋手本人，通过人脸识别结果评估是否为用户提供服务。
        </div>
        <div className="h3">二、授权与许可</div>
        <div className="p">
          如您点击“确认”或以其他方式选择接受本协议规则，则视为您在使用人脸识别服务时，同意并授权商汤获取、使用您在申请商汤服务过程中所提供的个人信息（包括姓名、身份证号）及人脸影像数据。如因年龄、智力等因素而不具有完全民事行为能力，请在监护人的陪同下提供以上个人信息。如您不同意本协议的任何内容，或者无法准确理解协议内容的解释，请不要进行后续操作。
        </div>
        <div className="h3">三、信息安全声明</div>
        <div className="p">
          商汤承诺对您的个人信息严格保密，并基于国家监管部门认可的加密算法进行数据加密传输，人脸数据商汤不会存储在服务系统中。如因不可抗力、计算机黑客袭击、系统故障、通讯故障、电脑病毒、恶意程序攻击及其他不可归因于商汤的情况而导致用户损失的，商汤不承担任何责任。
        </div>
        <div className="h3">四、协议的效力及变更</div>
        <div className="p">
          本协议在签署后立即生效，您在“元萝卜AI下棋机器人”小程序中点击“确认”或以其他方式选择接受本协议规则，即视为对本协议的签订。在不损害用户利益的前提下，商汤保留修改或增补本协议内容的权利，并以在“元萝卜AI下棋机器人”小程序中以通知的方式予以公布，无需另行单独通知您。若您在本协议内容通知变更后继续使用相关服务的，表示您已充分阅读、理解并接受变更后的协议内容，也将遵循变更后的协议内容使用相关服务。若您不同意变更后的协议内容，您应向商汤提出终止本协议并停止使用相关服务。
        </div>
        <div className="h3">五、纠纷的解决办法</div>
        <div className="p">
          本协议的订立、执行和解释及争议的解决均应适用中国法律。如本协议未尽事宜，以双方签署的《元萝卜AI下棋机器人用户注册协议》约定为准，如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，应向协议签订地有管辖权的人民法院提起诉讼。本协议签订地为中华人民共和国上海市徐汇区。
        </div>
      </div>
    </div>
  )
}

export default AgreementFace
